module.exports = __webpack_public_path__ + "img/ico_prize.d064f81d.svg";